import axios from 'axios';

const affiliatesToMarketIdMap = {
  'central':          '01',
  'centralbankac':    '24',
  'centralbankstl':   '20',
  'boonecounty':      '16',
  'branson':          '10',
  'bankcentral':      '45',
  'bankCentral':      '45',
  'jefferson':        '02',
  'lakeozarks':       '11',
  'midwest':          '14',
  'moberly':          '22',
  'oklahoma':         '29',
  'ozarks':           '27',
  'sedalia':          '15',
  'warrensburg':      '39',
  '01':               '01',
  '24':               '24',
  '20':               '20',
  '16':               '16',
  '11':               '11',
  '10':               '10',
  '02':               '02',
  '14':               '14',
  '22':               '22',
  '29':               '29',
  '27':               '27',
  '15':               '15',
  '39':               '39',
  '45':               '45',
};

const addOnMappings = {
  // Consumer Checking Add-ons
  '50267': 'checking_alerts', // alerts - checking
  '50268': 'checking_odp_cc', // Overdraft Protection - Credit Card Transfer
  '50369': 'checking_odp_savings', // Overdraft Protection - Checking and Savings Transfer
  '15016': 'checking_debit_card', // Debit Card
  '15017': 'checking_debit_mastercard', // Debit MasterCard
  '15019': 'checking_online_banking', // Online Banking
  '15020': 'checking_bill_pay', // Online & Mobile Bill Pay
  '15021': 'checking_money_manager', // Money Manager
  '15022': 'checking_mobile_banking', // Mobile Banking
  '15023': 'checking_mobile_deposit', // Mobile Deposit
  '15024': 'checking_p2p', // Person-to-Person Payments
  '15025': 'checking_zelle', // Zelle
  '15027': 'checking_estatements', // eStatements
  '15028': 'checking_overdraft_access', // Overdraft Access
  '15029': 'checking_odp_cc_legacy', // Overdraft Protection - Credit Card Transfer (Legacy)
  '15063': 'checking_remote_deposit', // Remote Deposit
  '15065': 'checking_positive_pay', // Positive Pay
  '15072': 'checking_odp_savings_legacy', // Overdraft Protection - Checking and Savings Transfer (Legacy)
  '15075': 'checking_edocuments', // eDocuments

  // Business Checking Add-ons
  '15042': 'business_debit_card', // Debit Card
  '15043': 'business_resubmit', // ReSubmitIt
  '15044': 'business_online_banking', // Online Banking
  '15045': 'business_bill_pay', // Bill Pay
  '15046': 'business_mobile_banking', // Mobile Banking
  '15050': 'business_estatements', // eStatements
  '15063': 'business_remote_deposit', // Remote Deposit
  '701': 'business_bill_pay_legacy', // Bill Pay (Legacy)
  '1156': 'business_direct_connect', // Direct Connect
  '1157': 'business_estatements_legacy', // eStatements (Legacy)
  '1160': 'business_direct_connect_legacy', // Direct Connect (Legacy)
  '1161': 'business_estatements_legacy2', // eStatements (Legacy 2)
  '1166': 'business_direct_connect_legacy2', // Direct Connect (Legacy 2)
  '1167': 'business_estatements_legacy3', // eStatements (Legacy 3)
};

const igniteToBottomLineIdMap = {
  '50233': 'checking_world_checking', //World Checking
  '50234': 'checking_preferred_interest', //Preferred Interest
  '50262': 'checking_mychoice_plus', //MaxMoney Checking
  '50235': 'checking_mychoice', //MyChoice Checking
  '50236': 'checking', //Free Checking
  '50224': 'savings', //SaveUp Savings
  '50237': 'savings_mm', //Online Money Market
  '50238': 'cd_traditional_ira', //Traditional IRA
  '50239': 'cd_roth_ira', //Roth IRA
  '50263': 'checking_hsa', //Health Savings Account
  '50252': 'cc_only_card', //The Only Card
  ...addOnMappings
};

const bottomLineFieldsMap = [
  {
    field: 'appRequest.primary.firstName',
    paramName: 'firstName'
  },
  {
    field: 'appRequest.primary.lastName',
    paramName: 'lastName'
  },
  {
    field: 'appRequest.primary.emailAddress',
    paramName: 'email'
  },
  {
    field: 'appRequest.primary.phone.homePhoneNumber',
    paramName: 'phone'
  },
  {
    field: 'appRequest.market.name',
    paramName: 'market'
  }
];

const debugLog = (environment, logMsg, logData) => {
  if(environment === 'development' || environment === 'staging'){
    console.log(logMsg, logData);
    debugger;
  }
};

export const sendToBottomLine = (dataForm, productList, marketSelected) => {
  const environment = ( window.ignite.getRunMode().toLowerCase() === 'production' ) ? 'production' : 'development';
  const products = productList.filter(p => igniteToBottomLineIdMap[p.id]).map(p => igniteToBottomLineIdMap[p.id]).join(',');
  const marketId = affiliatesToMarketIdMap.hasOwnProperty(marketSelected) ? affiliatesToMarketIdMap[marketSelected] : affiliatesToMarketIdMap.central;
  const jeffersonMarketId = '02';

  //determine API URL
  const jeffersonMarketUrl   = 'https://apply.jefferson-bank.com';
  const centralMarketUrl     = 'https://apply.centralbank.net';
  const environmentUrls = {
    PRODUCTION:    marketId === jeffersonMarketId
      ? jeffersonMarketUrl
      : centralMarketUrl,
    DEVELOPMENT:   'https://cbc-web.oflows.us'
  };
  const bottomLineURI = environment === "production" ? environmentUrls.PRODUCTION : environmentUrls.DEVELOPMENT;

  //prepare API data
  const data = {
    product: products,
    market: marketId,
    prefill: {}
  };
  bottomLineFieldsMap.map((mapping) => {
    data.prefill[mapping.field] = dataForm[mapping.paramName];
  });
  data.prefill["appRequest.market.name"] = marketId;

  debugLog(environment, 'Data to send', data);

  //Send data to OAO
  axios({
    method: 'post',
    url: `${bottomLineURI}/oflows/api/oao/workflow/prefill`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    withCredentials: true,
    data: data
  })
  .then(response => {
    if (response.data.msg || (response.data.result && response.data.result.status === false)) {
      // If a prefill error occurs, redirect the user to OAO
      debugLog(environment, 'Unable to prefill', response.data);
      window.open(`${bottomLineURI}/oao/?product=${products}&market=${marketId}`);
    } else {
      const _prefillToken = response.data.meta.tokens.prefillToken || '';
      // Session cookie
      const date = new Date();
      date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
      window.open(`${bottomLineURI}/oao/primaryinfo?product=${products}&market=${marketId}&prefillToken=${_prefillToken}`);
    }
  })
  .catch(error => {
    // If a prefill error occurs, redirect the user to OAO
    debugLog(environment, 'Prefill API call failed', error);
    window.open(`${bottomLineURI}/oao/?product=${products}&market=${marketId}`);
  });
};